import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../lifechronicles/LifeChroniclesHome.css';

import {
  faPiggyBank,
  faCalendarDays,
  faCheckCircle,
  faMobileScreen,
  faCloudMoon,
  faHandHoldingHeart,
  faTree,
  faStar,
  faSeedling,
  faGift,
  faFaceSmile,
  faBreadSlice,
  faBullseye,
  faHandsPraying,
  faHospitalUser,
  faMoneyBillWave,
  faEnvelopeOpenText,
  faExclamationTriangle,
  faPrescriptionBottleMedical,
  faHourglassEnd,
  faShoppingBasket,
  faFaceGrinHearts,
  faCalendarPlus,
  faCashRegister,
  faClipboardList,
  faGamepad,
  faTrash,
  faUsers,
  faBookOpen,
  faReceipt,
  faHeartCircleCheck,
  faTasks,
  faBrain,
  faSuitcase,
  faFolderOpen,
  faCar,
  faLeaf,
  faListCheck,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

export const categories = [
  { to: "/assets-list", icon: faPiggyBank, label: "Assets", bgColor: "bg-green-600", textColor: "text-white" },
  { to: "/calendar-list", icon: faCalendarDays, label: "Calendar", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/checklist-list", icon: faCheckCircle, label: "Checklist", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/digitaltime-list", icon: faMobileScreen, label: "DigitalTime", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/dreams-list", icon: faCloudMoon, label: "Dreams", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/empathy-list", icon: faHandHoldingHeart, label: "Empathy", bgColor: "bg-pink-600", textColor: "text-white" },
  { to: "/environment-list", icon: faTree, label: "Environment", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/expense-list", icon: faStar, label: "Expense", bgColor: "bg-purple-600", textColor: "text-white" },
  { to: "/events-list", icon: faStar, label: "Events", bgColor: "bg-purple-600", textColor: "text-white" },
  { to: "/experience-list", icon: faSeedling, label: "Experience", bgColor: "bg-indigo-700", textColor: "text-white" },
  { to: "/gift-list", icon: faGift, label: "Gifts", bgColor: "bg-red-500", textColor: "text-white" },
  { to: "/feelings-list", icon: faFaceSmile, label: "Feelings", bgColor: "bg-pink-600", textColor: "text-white" },
  { to: "/food-list", icon: faBreadSlice, label: "Food", bgColor: "bg-yellow-700", textColor: "text-white" },
  { to: "/goal-list", icon: faBullseye, label: "Goals", bgColor: "bg-teal-700", textColor: "text-white" },
  { to: "/gratitude-list", icon: faHandsPraying, label: "Gratitude", bgColor: "bg-orange-700", textColor: "text-white" },
  { to: "/income-list", icon: faEnvelopeOpenText, label: "Income", bgColor: "bg-purple-700", textColor: "text-white" },
  { to: "/investments-list", icon: faMoneyBillWave, label: "Investments", bgColor: "bg-green-700", textColor: "text-white" },
  { to: "/invitations-list", icon: faEnvelopeOpenText, label: "Invitations", bgColor: "bg-purple-700", textColor: "text-white" },
  { to: "/issues-list", icon: faExclamationTriangle, label: "Issues", bgColor: "bg-red-700", textColor: "text-white" },
  { to: "/loans-list", icon: faMoneyBillWave, label: "Loans", bgColor: "bg-blue-600", textColor: "text-white" },
  { to: "/illness-list", icon: faHospitalUser, label: "Illness", bgColor: "bg-teal-800", textColor: "text-white" },
  { to: "/medicine-list", icon: faPrescriptionBottleMedical, label: "Medicine", bgColor: "bg-teal-800", textColor: "text-white" },
  { to: "/meditation-list", icon: faLeaf, label: "Meditations", bgColor: "bg-indigo-800", textColor: "text-white" },
  { to: "/missed-opportunities-list", icon: faHourglassEnd, label: "Missed-opportunities", bgColor: "bg-red-800", textColor: "text-white" },
  { to: "/monthly-essentials-plan-list", icon: faShoppingBasket, label: "Monthly-essentials-plan", bgColor: "bg-yellow-700", textColor: "text-white" },
  { to: "/mood-list", icon: faFaceGrinHearts, label: "Mood", bgColor: "bg-yellow-400", textColor: "text-red" },
  { to: "/routine-others-list", icon: faCalendarPlus, label: "Routine-Others", bgColor: "bg-pink-500", textColor: "text-white" },
  { to: "/petty-account-list", icon: faCashRegister, label: "Petty-Account", bgColor: "bg-yellow-600", textColor: "text-white" },
  { to: "/planner-list", icon: faClipboardList, label: "Planner", bgColor: "bg-teal-500", textColor: "text-white" },
  { to: "/play-sports-list", icon: faGamepad, label: "Play-Sports", bgColor: "bg-purple-800", textColor: "text-white" },
  { to: "/entertainment-list", icon: faGamepad, label: "Entertainment", bgColor: "bg-purple-800", textColor: "text-white" }, 
  { to: "/regrets-list", icon: faTrash, label: "Regret", bgColor: "bg-gray-800", textColor: "text-white" },
  { to: "/socialactivity-list", icon: faUsers, label: "Social-Activity", bgColor: "bg-indigo-800", textColor: "text-white" },
  { to: "/study-list", icon: faBookOpen, label: "Study", bgColor: "bg-indigo-800", textColor: "text-white" },
  { to: "/subscription-list", icon: faReceipt, label: "Subscriptions", bgColor: "bg-teal-800", textColor: "text-white" },
  { to: "/sympathy-list", icon: faHeartCircleCheck, label: "Sympathy", bgColor: "bg-green-800", textColor: "text-white" },
  { to: "/tasks-list", icon: faTasks, label: "Task", bgColor: "bg-gray-700", textColor: "text-white" },
  { to: "/thoughts-list", icon: faBrain, label: "Thoughts", bgColor: "bg-blue-800", textColor: "text-white" },
  { to: "/todo-list", icon: faListCheck, label: "ToDo", bgColor: "bg-purple-500", textColor: "text-white" },
  { to: "/travels-list", icon: faSuitcase, label: "Travels", bgColor: "bg-yellow-800", textColor: "text-white" },
  { to: "/unspecified-list", icon: faFolderOpen, label: "Unspecified", bgColor: "bg-red-800", textColor: "text-white" },
  { to: "/visits-list", icon: faCar, label: "Visit", bgColor: "bg-red-900", textColor: "text-white" },
  { to: "/waste-list", icon: faTrash, label: "Waste", bgColor: "bg-gray-900", textColor: "text-white" },
];


const MSMESelfChroniclesHome = () => {
    const navigate = useNavigate();
    const [droppedItems, setDroppedItems] = useState([]);
    const [draggingIndex, setDraggingIndex] = useState(null);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const [swipingItem, setSwipingItem] = useState(null);
    const [swipeOffset, setSwipeOffset] = useState(0);
    const [isSwiping, setIsSwiping] = useState(false);
    const [touchStartY, setTouchStartY] = useState(null);
    const [isCategorySwiping, setIsCategorySwiping] = useState(false);
    const touchStartRef = useRef(0);
    const gridRef = useRef(null);

    useEffect(() => {
        const saved = localStorage.getItem('droppedItems');
        if (saved) {
            const labels = JSON.parse(saved);
            const items = labels.map(label => categories.find(c => c.label === label)).filter(Boolean);
            setDroppedItems(items);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('droppedItems', JSON.stringify(droppedItems.map(item => item.label)));
    }, [droppedItems]);

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const data = e.dataTransfer.getData('text/plain');
        if (!isNaN(parseInt(data))) return; // Reorder drop, handled by items
        const label = data;
        const item = categories.find(c => c.label === label);
        if (item && !droppedItems.some(d => d.label === item.label) && droppedItems.length < 10) {
            setDroppedItems([...droppedItems, item]);
        }
    };

    const removeItem = (labelToRemove) => {
        setDroppedItems(droppedItems.filter(d => d.label !== labelToRemove));
    };

    const handleReorderDrop = (e, dropIndex) => {
        e.preventDefault();
        const draggedIndexStr = e.dataTransfer.getData('text/plain');
        const draggedIndex = parseInt(draggedIndexStr);
        if (draggedIndex === dropIndex || isNaN(draggedIndex)) return;
        const newItems = [...droppedItems];
        const [draggedItem] = newItems.splice(draggedIndex, 1);
        newItems.splice(dropIndex, 0, draggedItem);
        setDroppedItems(newItems);
        setDraggingIndex(null);
    };

    const handleDragStart = (e, index) => {
        setDraggingIndex(index);
        e.dataTransfer.setData('text/plain', index.toString());

        // Drag preview styling
        const preview = e.currentTarget.cloneNode(true);
        preview.style.opacity = '0.7';
        preview.style.transform = 'scale(1.05)';
        preview.style.filter = 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))';
        preview.style.position = 'absolute';
        preview.style.pointerEvents = 'none';
        preview.style.zIndex = '9999';
        document.body.appendChild(preview);
        e.dataTransfer.setDragImage(preview, 20, 20);

        // Cleanup on drag end
        const cleanup = () => {
            if (document.body.contains(preview)) {
                document.body.removeChild(preview);
            }
            setDraggingIndex(null);
        };
        e.currentTarget.addEventListener('dragend', cleanup, { once: true });
    };

    const handleTouchStart = (e, index) => {
        e.preventDefault();
        touchStartRef.current = e.touches[0].clientX;
        setSwipingItem(index);
        setSwipeOffset(0);
        setIsSwiping(false);
    };

    const handleTouchMove = (e, index) => {
        if (swipingItem !== index) return;
        e.preventDefault();
        const currentX = e.touches[0].clientX;
        const deltaX = currentX - touchStartRef.current;
        setSwipeOffset(deltaX);
        if (Math.abs(deltaX) > 20) {
            setIsSwiping(true);
        }
    };

    const handleTouchEnd = (e, index) => {
        if (swipingItem === index) {
            const deltaX = e.changedTouches[0].clientX - touchStartRef.current;
            if (deltaX < -80) {
                removeItem(droppedItems[index].label);
            }
            setSwipingItem(null);
            setSwipeOffset(0);
            setIsSwiping(false);
        }
    };

    const handleCategoryTouchStart = (e) => {
        setTouchStartY(e.touches[0].clientY);
        setIsCategorySwiping(false);
    };

    const handleCategoryTouchMove = (e) => {
        if (touchStartY !== null) {
            const deltaY = e.touches[0].clientY - touchStartY;
            if (Math.abs(deltaY) > 20) {
                setIsCategorySwiping(true);
            }
        }
    };

    const handleCategoryTouchEnd = (e, category) => {
        if (touchStartY !== null) {
            const deltaY = e.changedTouches[0].clientY - touchStartY;
            if (isCategorySwiping && deltaY < -50) {
                e.preventDefault();
                const item = category;
                if (item && !droppedItems.some(d => d.label === item.label) && droppedItems.length < 10) {
                    setDroppedItems([...droppedItems, item]);
                }
            }
            setTouchStartY(null);
            setIsCategorySwiping(false);
        }
    };

    const getItemStyle = (index) => {
        let style = {};
        if (draggingIndex !== null && draggingIndex !== index) {
            style = {
                ...style,
                transition: 'transform 0.3s ease-in-out',
                transform: 'scale(0.98)'
            };
        }
        if (swipingItem === index) {
            const swipeTransform = `translateX(${swipeOffset}px)`;
            style = {
                ...style,
                transition: 'none',
                transform: style.transform ? `${style.transform} ${swipeTransform}` : swipeTransform
            };
        }
        return style;
    };

    const handleItemClick = (e, item) => {
        if (draggingIndex !== null || isSwiping) {
            e.preventDefault();
            return;
        }
        navigate(item.to);
    };

    return (
        <div>
            <div className="flex flex-col items-center mt-1 py-4 px-4 bg-black border border-pink-400 h-auto rounded-lg">
                <p className="text-lg lg:text-xl mb-2 text-yellow-200">Owner's Self Reflection - Task & Moods</p>
                <div 
                    ref={gridRef}
                    className="w-full max-w-6xl mt-4 p-6 border-2 border-dashed border-gray-600 rounded-lg bg-gray-900 min-h-40 flex items-center justify-center relative"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                >
                    {droppedItems.length === 0 ? (
                      <>
                        <p className="hidden md:block text-gray-400 text-center text-lg">
                          🖱️ Drag-Drop your most frequent tools.
                        </p>
                        <p className="block md:hidden text-gray-400 text-center text-lg">
                          👆 Hold and Swipe Up your most frequent tools.
                        </p>
                      </>
                    ) : (
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-10 gap-3 w-full relative">
                            {droppedItems.map((item, index) => (
                                <div 
                                    key={item.label} 
                                    draggable={true}
                                    onDragStart={(e) => handleDragStart(e, index)}
                                    onTouchStart={(e) => handleTouchStart(e, index)}
                                    onTouchMove={(e) => handleTouchMove(e, index)}
                                    onTouchEnd={(e) => handleTouchEnd(e, index)}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) => handleReorderDrop(e, index)}
                                    onClick={(e) => handleItemClick(e, item)}
                                    style={getItemStyle(index)}
                                    className={`relative flex flex-col items-center p-2 rounded-md ${item.bgColor} ${item.textColor} shadow-sm transition-all duration-300 ease-in-out hover:scale-105 cursor-pointer ${draggingIndex === index ? 'opacity-50 scale-105' : ''}`}
                                >
                                    <button 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            removeItem(item.label);
                                        }}
                                        className="absolute -top-0.5 -right-0.5 bg-red-500 text-white rounded-full w-3.5 h-3.5 flex items-center justify-center text-[8px] hover:bg-red-600 transition-colors"
                                    >
                                        <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                    <FontAwesomeIcon icon={item.icon} size="sm" className="mb-1" />
                                    <span className="text-xs text-center whitespace-nowrap">{item.label}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div className='flex flex-col flex-wrap justify-center gap-4 mt-2 text-sm'>
                    <div className="grid grid-cols-4 lg:grid-cols-8 gap-6">
                        {categories.map((category, index) => (
                            <Link 
                                key={index} 
                                to={category.to} 
                                draggable={true}
                                onDragStart={(e) => {
                                    e.dataTransfer.setData('text/plain', category.label);
                                }}
                                onTouchStart={handleCategoryTouchStart}
                                onTouchMove={handleCategoryTouchMove}
                                onTouchEnd={(e) => handleCategoryTouchEnd(e, category)}
                                className={`flex flex-col items-center p-6 rounded-lg ${category.bgColor} ${category.textColor} shadow-lg hover:shadow-2xl transition-shadow duration-300`}
                            >
                                <FontAwesomeIcon icon={category.icon} size="x" className="mb-2" />
                                <span className="text-m flex items-center justify-center text-center">{category.label}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
            <footer className="bg-gray-900 border-t border-gray-800 text-gray-400 py-4">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                    <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</div>
                    <div className="flex flex-wrap gap-4 text-sm">
                    <Link to="/about-us" className="hover:text-teal-300">About</Link>
                    <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
                    <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
                    <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default MSMESelfChroniclesHome;